/**
 * @file _view/_menu.js
 */
(function ($) {
	'use strict';

	/**
	 * @namespace Menu
	 * @constructor
	 * @classdesc global navigation
	 * @param {object} $e -対象となる jQuery オブジェクト
	 */

	var Menu = function ($e) {
		this._$e = $e;
		this._$target = this._$e.next('.list--global-navigation__sub-menu');
		this._$e.on('hover', this.showSubMenu.bind(this));
	};


	/**
	 * @memberOf Menu
	 * @const
	 */
	Menu._classname = 'Menu';


	Menu.prototype.showSubMenu = function() {

	};

	module.exports = Menu;
})(jQuery);
